import { JourneyResponse, YardBlockDto } from '@yard/app/api'
import { serializeBlockPositions } from '@yard/utils'
import { YardIssueDto, YardIssueStatus, YardIssueTypeDummy } from '../models/yard-issue.model'
import { YardIssueItem } from '../stores/yard-issue.store'

export const mapYardIssueItemToYardIssueDto = (
  item: YardIssueItem,
  journeys: Record<number, JourneyResponse>,
  yardBlocks: Record<string, YardBlockDto>,
): YardIssueDto => {
  const containerNumbers = item.conflictingJourneyIds.map(journeyId => {
    const journey = journeys[journeyId]
    return journey?.container?.containerNumber ?? ''
  })

  const blockPositions = item.positions.map(pos => ({
    blockId: item.blockId,
    bay: pos.bay,
    row: pos.row,
    tier: pos.tier,
  }))

  const serializedPositions = serializeBlockPositions(yardBlocks, blockPositions)

  return {
    issueId: item.issueId,
    blockId: item.blockId,
    allocationRuleId: item.allocationRuleId,
    issueType: item.issueType as YardIssueTypeDummy,
    issueStatus: item.issueStatus ?? YardIssueStatus.Unresolved,
    conflictingJourneyIds: item.conflictingJourneyIds,
    containerIds: item.containerIds,
    positions: item.positions,
    violatingImoClass: item.violatingImoClass,
    prohibitedBelowImoClass: item.prohibitedBelowImoClass,
    maxTiersValue: item.maxTiersValue,
    placedImoClass: item.placedImoClass,
    conflictingImoClass: item.conflictingImoClass,
    requiredDistance: item.requiredDistance,
    actualBayDistance: item.actualBayDistance,
    segregationConflictingJourneyId: item.segregationConflictingJourneyId,
    isProhibited: item.isProhibited,
    serializedPositions,
    containerNumbers,
  }
}
